module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/world_map-ce229512e8d5c1829ba9daaab0b79e75.svg&quot;;"